module.exports = __webpack_public_path__ + "media/applicants/yogurt2-c96afa48.png";